import { Component, OnInit } from '@angular/core';
import { SystemInfoService } from '../../common/services/system-info.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ProfileBuilderService } from '../../common/services/profile-builder.service';
import * as _ from 'lodash';

import { GaService } from '../../common/services/ga.service';
import { JwtService } from '../../common/services/jwt.service';

@Component({
  selector: 'system-profile',
  templateUrl: './system-profile.component.html',
  styleUrls: ['./system-profile.component.css'],
  providers: [SystemInfoService, ProfileBuilderService]
})
export class SystemProfileComponent implements OnInit {
  public isGenInfoCollapsed: boolean = false;
  public isAddressCollapsed: boolean = false;
  public isCSuiteCollapsed: boolean = false;
  public isMapCollapsed: boolean = false;
  public isAffiliatedCollapsed: boolean = true;
  public isAffiliatedMapCollapsed: boolean = true;


  system;
  systemLocation;
  systemGeneralInfo;
  systemIndividuals;
  systemAffiliations;
  filterProfileBy = 'All Items';
  profileFilters = [];

  // spinner
  gettingSystemData = false;

  // id used to get system data
  selectedId;

  // Tableau
  tableauJWT = null
  showInnerHtml: boolean = false;
  showInnerHtmlAffiliates: boolean = false;
  collapsedMap:boolean = true

  constructor(
    private systemSearch: SystemInfoService,
    private profileBuilder: ProfileBuilderService,
    private route: ActivatedRoute,
    private router: Router,
    private gaService: GaService,
    private jwtService: JwtService,
  ) { }

  ngOnInit() {
    this.selectedId = this.route.snapshot.params['id'];

    // we subscribe to route params to reload data if id in url changes
    this.route.params.subscribe(params => {
      this.paramsChanged(params['id']);
    });

    this.getSystemData(this.selectedId);

    this.jwtService.getToken()
      .filter(token => token !== null)
      .subscribe(token => {
        this.tableauJWT = token;
      });
  }



  get tableuSelectedID(): string {
    return "000" + this.selectedId
  }

  updateInnerHTMLToken() {
    if (this.showInnerHtml && this.tableauJWT) {
      const tableauContainer = document.getElementById('tableauContainerSystem');
      if (tableauContainer) {
        tableauContainer.innerHTML = `

        `;
      }
    }
  }

  updateInnerHTMLTokenAffiliates() {
    if (this.showInnerHtmlAffiliates && this.tableauJWT) {
      const tableauContainer = document.getElementById('tableauContainerSystemAffiliates');
      if (tableauContainer) {
        tableauContainer.innerHTML = `

        `;
      }
    }
  }

  getSystemData(id) {
    this.gettingSystemData = true;
    this.systemSearch.getSystem(id).subscribe(
      ({ data }) => {
        this.gettingSystemData = false;
        this.system = data.getSystem;
        this.createSysObjs(this.system);
      },
      error => {
        this.gettingSystemData = false;
        console.log(error);
      }
    );
  }

  paramsChanged(id) {
    // we only fetch new system data if id is different
    if (this.selectedId !== id) {
      this.getSystemData(id);
    }
  }

  backToSearch() {
    this.router.navigate(['searchResults']);
  }

  createSysObjs(system) {
    this.createGenInfoSysObj(system);
    this.createLocactionSysObj(system);
    this.createIndividualsSysObj(system);
    this.createAffHospitalSysObj(system);
    this.checkDropDownFilters();
  }

  checkDropDownFilters() {
    let tempArr = ['All Items', 'General Information', 'Address', 'Map'];
    if (!_.isEmpty(this.systemIndividuals)) {
      tempArr.push('C-Suite');
    }
    if (!_.isEmpty(this.systemAffiliations)) {
      tempArr.push('Affiliated Hospitals');
      tempArr.push('Affiliated Hospitals Map');
    }
    this.profileFilters = tempArr;
  }

  createGenInfoSysObj(system) {
    this.systemGeneralInfo = this.profileBuilder.createSystemGenInfoObj(system);
  }

  createLocactionSysObj(system) {
    this.systemLocation = this.profileBuilder.createAddressObj(system);
  }

  createIndividualsSysObj(system) {
    this.systemIndividuals = this.profileBuilder.createCSuiteObj(system);
  }

  createAffHospitalSysObj(system) {
    this.systemAffiliations = this.profileBuilder.createCodesObj(system, 'facility');
  }

  toggle(event) {
    event.preventDefault();
    this.filterProfileBy = event.target.innerHTML;

    // google analytics
    this.gaService.addProfileFilterClick(this.filterProfileBy);
  }

  expandAll() {
    this.isGenInfoCollapsed = false;
    this.isAddressCollapsed = false;
    this.isCSuiteCollapsed = false;
    this.isAffiliatedCollapsed = false;
    this.isMapCollapsed = false;
    this.isAffiliatedMapCollapsed = false;
  }

  collapseAll() {
    this.isGenInfoCollapsed = true;
    this.isAddressCollapsed = true;
    this.isCSuiteCollapsed = true;
    this.isAffiliatedCollapsed = true;
    this.isMapCollapsed = true;
    this.isAffiliatedMapCollapsed = true;
  }

  toggleMap() {
    this.collapsedMap = !this.collapsedMap
    this.showInnerHtml = !this.showInnerHtml;
    if (this.showInnerHtml) {
      //this.updateInnerHTMLToken();
    }
  }
  toggleAffiliatedMap() {
    this.isAffiliatedMapCollapsed = !this.isAffiliatedMapCollapsed
    this.showInnerHtmlAffiliates = !this.showInnerHtmlAffiliates;
    if (this.showInnerHtmlAffiliates) {
      //this.updateInnerHTMLTokenAffiliates();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/profile/system-profile/system-profile.component.ts